<span class="p-input-icon-left search-box">
    <i class="search-material">
        <span class="material-icons">search</span>
    </i>
    <input [(ngModel)]="filter" #searchInput pInputText type="text" (input)="change($event.target.value)" class="p-inputtext-sm py-2"
    [placeholder]="placeholder" />
    <i *ngIf="searchInput.value" class="cancel-icon pi pi-times cursor-pointer notranslate"
        (click)="clear(searchInput)"></i>
</span>